// [Route("/API/Role")];

import { ApiUtility } from "../../Utilities/ApiUtility.axios";

export enum DBRecordStatusRole {
  All,
  Active,
  Deleted,
  MarkAsDeleted,
  Archived,
}

class CustomerRoleServices {
  private route = "/V1/API/Acc_Role";

  getAllRoleIdNameList = (userId: string) =>
    ApiUtility.get(`${this.route}/${userId}/AllRoles`);

  getRoleById = (userId: string, roleId?: string) =>
    ApiUtility.get(`${this.route}/${userId}/${roleId}`);

  postCustomerRole = (userId: string, param: any, roleId?: string) =>
    ApiUtility.postForm(
      `${this.route}/${userId}${roleId ? "/" + roleId : ""}`,
      param
    );

  getRoleList = (
    userId: string,
    start: number,
    length: any,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    status?: any,
    requestModel?: any
  ) =>
    ApiUtility.getResult(`${this.route}/${userId}/GetList`, {
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      requestModel,
    });

  // https: //localhost:7142/V1/API/Role/67bc19337874a46e78232221111/changeStatus?id=68219bffdc34cc73b1962891&status=2

  changeRoleStatus = (userId: string, id: string, status: DBRecordStatusRole) =>
    ApiUtility.postForm(
      `${this.route}/${userId}/changeStatus?id=${id}&status=${status}`,
      {}
    );

  rolesUserList = (userId: string, roleId: string) =>
    ApiUtility.get(`${this.route}/${userId}/UserList/${roleId}`);
}
export default new CustomerRoleServices();
